export const CONCERNS_KEY = ['notification-concerns'] as const;
export const TEMPLATES_KEY = ['notification-templates'] as const;
